module.exports = __webpack_public_path__ + "static/media/step3.93d97808.png";


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfCommon/Pay3/images/sber/step3.png
// module id = 706
// module chunks = 0